import React from 'react';
import styled from 'styled-components';
import { Progress } from '../application/Progress';
import { BaseLayout } from './BaseLayout';
import { devices } from '../../../util/cssMediaQuery.util';
import { FixedLogo } from '../../../components/layout/Logo';

const Sidebar = styled.aside`
  background: ${({ theme }) => theme.primaryColor};
  display: none;
  ${devices.tablet} {
    display: inherit;
  }
`;

const TwoColWrap = styled.div`
  display: grid;
  min-height: 100vh;
  grid-template-columns: 1fr;
  ${devices.tablet} {
    grid-template-columns: 0.4fr 0.6fr;
  }
  ${devices.laptopL} {
    grid-template-columns: 0.35fr 0.65fr;
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 40px);
  padding: 20px 0;

  form {
    height: 100%;
  }
  ${devices.tablet} {
    form {
      height: initial;
    }
  }

  ${devices.tablet} {
    justify-content: center;
    padding: 20px 80px;
  }
`;

/**
 * A two column layout, GlobalStyles wrapped, with a progress sidebar.
 * The children node is rendered inside a '<main>' element that fills 60%,
 * 65%, or the entire screen (on mobile) depending on the screen/device size.
 */
export function ApplicationLayout(props: { logo?: string; children: React.ReactNode }) {
  return (
    <BaseLayout>
      <TwoColWrap>
        <Sidebar>
          <Progress />
          <FixedLogo>
            <img alt="logo" src={props.logo} />
          </FixedLogo>
        </Sidebar>
        <Main>
          {props.children}
        </Main>
      </TwoColWrap>
    </BaseLayout>
  );
}
